<script lang="ts">
	//Services
	import { format } from '../../../../services/i18n';
	import { localReq, postReq } from '../../../../services/http';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	import { getNumberInputConfig } from '../../../../helpers/number_input_helpers';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Design system components
	import { Button, Input, Text, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);
	let settings = readDeviceSettings(id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore ?? settings;
	let value = settings.power;
	let cache = value;
	const min = 0,
		max = 3500,
		unit = 'W';
	let loading = false;
	let localIp = get_local_ip(id);

	$: error =
		+value < min || +value > max
			? $format('error_out_of_range', {
					default: `Value ${value}${unit} is out of range. Please provide a value within the limits. (${min}${unit} — ${max}${unit})`,
					values: { value, max, min, unit },
				})
			: '';

	const setConsumption = async () => {
		if (cache !== value) {
			let res;
			value = Math.round(value);
			loading = true;
			if (localIp) {
				res = await localReq(device, `${localIp}/settings`, 'post', {
					power: value,
				});
			} else {
				res = await postReq(`/device/generic_command`, {
					id: id,
					command: `power`,
					payload: `{"power":${value}}`,
				});
			}

			if (res.isok) {
				settings.power = value;
				devices_settings.update_devices_settings(id, settings);
				toast.open({
					type: 'success',
					title: $format('power_consumption_output_on_scc_toast', {
						values: { value },
						default: `Power consumption was set to ${value}w.`,
					}),
				});
				cache = value;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				value = cache;
			}
			loading = false;
		}
	};
</script>

<Text styleType="body-small" class="mb-s">
	{$format('set_power_consumption_output_on', {
		default: 'Set the power consumption (W) when the output is switched ON:',
	})}
</Text>
<Input
	{...getNumberInputConfig()}
	class="mb-s"
	bind:value
	size="m"
	label={value}
	{error}
	{min}
	{max}
	on:enter={setConsumption}
	id="input-zpbmcbn"
	aria-labelledby="input-zpbmcbn"
/>
<Button class="mt-s" {loading} size="m" width="full" on:click={setConsumption}
	>{$format('button_save')}</Button
>
